<template>
  <div>
    <Modal
      title="大項游戏管理"
      width="700"
      v-model="modalstate"
      :transfer="false"
    >
      <lida-table
        :propscolumns="columns"
        :data="items"
        :sortStatus="false"
      ></lida-table>
      <div slot="footer">
        <Button
          type="primary"
          @click="modalstate = !modalstate"
        >取消</Button>
        <Button
          type="error"
          @click="modifygamePJupdop"
        >修改</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import triggerColumns from "@/mixins/triggerColumns"
export default {
  name: 'ModalElectronicBigGame',
  mixins: [triggerColumns],
  props: {
    siteid: [String, Number],
  },
  data () {
    return {
      modalstate: false,
      sortSate: true,
      columns: {
        gamename: {
          title: '項目名称',
          key: 'gamename',
          align: 'center'
        },
        idop: {
          title: '开启/关闭',
          key: 'title',
          align: 'center',
          renderHeader: (this.triggerHeaderIdop),
          render: (h, params) => this.triggerIdop(h, params, 'gametypeid')
        }
      },
      items: []
    }
  },
  computed: {
    ...mapGetters(['getmember'])
  },
  watch: {
    modalstate (val) {
      // if (!val) return
      // this.getSiteGameTriggerList(this.siteid)
    }
  },
  methods: {
    trigger (companyid) {
      this.modalstate = true
      this.getgamePJAllList(this.siteid, companyid)
    },
    async getgamePJAllList (val, companyid) {
      try {
        const res = await this.$axios.cq9.getgamePJAllList({
          stid: val,
          hallsid: companyid
        })
        if ('status' in res && res.status === 0) return
        this.items = res.data.map(it => {
          // const nameset = it.nameset ? it.nameset.find(it => it.lang.toLowerCase() == 'zh-cn') : null
          it.idop = Number(it.upidop)
          // it.gamename = nameset ? nameset.name : null
          it.defaultidop = it.upidop
          it.idopText = it.upidop ? '开启' : '关闭'
          return it
        })
      } catch (error) {
        console.error(error);
        this.$Message.error('取得错误');
      }
    },
    async modifygamePJupdop () {
      const obj = {
        loid: this.getmember.pid,
        stid: this.siteid,
        gameitme: this.modifyArray(this.items, (it) => ({ gametypeid: it.gametypeid, idop: it.idop }))
      }
      if (!obj.gameitme.length) return this.$Message.warning("请选择修改游戏");
      try {
        const res = await this.$axios.cq9.modifygamePJupdop(obj)
        if (res.status === 1) {
          this.$Message.success("已更改");
          this.modalstate = false;
          this.items = []
        }
      } catch (error) {
        console.log(error);
        this.$Message.error('修改游戏开关错误');
      }
    }
  }
}
</script>